import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './quantile.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Negative binomial distribution quantile function.
*
* @module @stdlib/stats/base/dists/negative-binomial/quantile
*
* @example
* var quantile = require( '@stdlib/stats/base/dists/negative-binomial/quantile' );
*
* var y = quantile( 0.9, 20.0, 0.2 );
* // returns 106
*
* y = quantile( 0.9, 20.0, 0.8 );
* // returns 8
*
* var myquantile = quantile.factory( 10.0, 0.5 );
* y = myquantile( 0.1 );
* // returns 5
*
* y = myquantile( 0.9 );
* // returns 16
*/

// MODULES //
var setReadOnly = __var_0__;
var quantile = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( quantile, 'factory', factory );


// EXPORTS //
export default quantile;
